import '@shoelace-style/shoelace/dist/components/alert/alert.js';
import '@shoelace-style/shoelace/dist/components/icon/icon.js';

type ToastType = 'info' | 'success' | 'warn' | 'error';

const TOAST_BG: Record<ToastType, string> = {
    info: '#e0f2fe',
    success: '#dcfce7',
    warn: '#fef9c3',
    error: '#fee2e2',
};

const TOAST_BORDER: Record<ToastType, string> = {
    info: '#7dd3fc',
    success: '#86efac',
    warn: '#fde047',
    error: '#fca5a5',
};

const TOAST_TEXT: Record<ToastType, string> = {
    info: '#075985',
    success: '#166534',
    warn: '#854d0e',
    error: '#991b1b',
};

function ensureStyle(): void {
    if (document.getElementById('sl-toast-style')) return;
    const style = document.createElement('style');
    style.id = 'sl-toast-style';
    style.textContent = `
        #sl-toast-container {
            position: fixed;
            top: 16px;
            right: 16px;
            z-index: 99999;
            display: flex;
            flex-direction: column;
            gap: 8px;
        }
        #sl-toast-item::part(base) {
            background-color: var(--toast-bg, #fff);
            border-color: var(--toast-border, #ccc);
            color: var(--toast-text, #333);
        }
    `;
    document.head.appendChild(style);
}

export function showToast(
    message: string,
    type: string = 'info',
    duration = 3000
): void {
    const validTypes: ToastType[] = ['info', 'success', 'warn', 'error'];
    const t: ToastType = validTypes.includes(type as ToastType)
        ? (type as ToastType)
        : 'info';

    const icons: Record<ToastType, string> = {
        info: 'info-circle',
        success: 'check2-circle',
        warn: 'exclamation-triangle',
        error: 'exclamation-octagon',
    };

    ensureStyle();

    const CONTAINER_ID = 'sl-toast-container';
    let container = document.getElementById(CONTAINER_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = CONTAINER_ID;
        document.body.appendChild(container);
    }

    // const oldToast = document.getElementById('sl-toast-item');
    // if (oldToast) oldToast.remove();

    const alert = document.createElement('sl-alert');
    alert.id = 'sl-toast-item';
    alert.setAttribute('variant', t);
    alert.setAttribute('closable', '');
    alert.setAttribute('duration', String(duration));
    alert.innerHTML = `<sl-icon slot="icon" name="${icons[t]}"></sl-icon>${message}`;

    alert.style.setProperty('--toast-bg', TOAST_BG[t]);
    alert.style.setProperty('--toast-border', TOAST_BORDER[t]);
    alert.style.setProperty('--toast-text', TOAST_TEXT[t]);

    container.appendChild(alert);
    (alert as any).toast();
}